import { general_states } from "../../utils/staticEnums";
import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const STOCK_BASE = "/businessintelligence";
const buildUrl = (endpoint) => STOCK_BASE + endpoint;

const ordersApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        saveBusinessIntelligenceReport: builder.mutation({
            query: (data) => ({
                url: buildUrl(`/report`),
                method: 'POST',
                body:data,
            }),

            // Saving recomputes the report's detail + chart pre-agg, so refresh the report views and dashboards too.
            invalidatesTags: (result, error, arg) => [{ type: `BusinessIntelligenceMenu`}, { type: 'BusinessIntelligence' }, { type: 'BusinessIntelligenceDashboards' }],
        }),
        getBusinessIntelligenceReports: builder.query({
            query: () => ({
                url: buildUrl(`/report`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'BusinessIntelligenceReports' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        // The shipper filter options a relation picks from: the carrier codes behind its own shipments.
        getBiRelationShipperCodes: builder.query({
            query: () => ({
                url: buildUrl(`/shippercodes`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'BusinessIntelligence' }],
        }),
        getBusinessIntelligenceMenu: builder.query({
            query: () => ({
                url: buildUrl(`/menu`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'BusinessIntelligenceMenu' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        getBiDetails2: builder.query({
            query: ({ args, invalidate }) => {
                let url = buildUrl(`/details?page=${args.page}&size=${args.size}`);
                if (args.sortBy) {
                    url += `&sortBy=${args.sortBy}`;
                }
                if (args.sortDirection) {
                    url += `&sortDirection=${args.sortDirection}`;
                }
                return {
                    url,
                    method: 'POST',
                    body: args.body,
                };
            },
            providesTags: () => [{ type: 'BusinessIntelligence' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        getBiDetailsById: builder.query({
            query: (id) => ({
                url: buildUrl(`/details/${id}`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'BusinessIntelligence' }],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        getBiPivotRowDetail: builder.query({
            query: (body) => ({
                url: buildUrl(`/pivotdetail`),
                method: 'POST',
                body,
            }),
            providesTags: () => [{ type: 'BusinessIntelligence' }],
        }),
        deleteBiReportById: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/report/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, arg) => [{ type: `BusinessIntelligenceMenu`}],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        editBiReportById: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/report/${id}`),
                method: 'PUT',
            }),
            invalidatesTags: (result, error, arg) => [{ type: `BusinessIntelligenceMenu`}],
          //  onQueryStarted: muiDataGridStarted.bind(null, 'getOrders', 'Orders'),
        }),
        editBiReportById: builder.mutation({
            query: (data) => ({
                url: buildUrl(`/report/${data.id}`),
                method: 'PUT',
                body:data,
            }),

            // Updating recomputes the report's detail + chart pre-agg, so refresh the report views and dashboards too.
            invalidatesTags: (result, error, arg) => [{ type: `BusinessIntelligenceMenu`}, { type: 'BusinessIntelligence' }, { type: 'BusinessIntelligenceDashboards' }],
        }),
        getBiDashboards: builder.query({
            query: () => ({
                url: buildUrl(`/dashboards`),
                method: 'GET',
            }),
            providesTags: () => [{ type: 'BusinessIntelligenceDashboards' }],
        }),
        getBiDashboardById: builder.query({
            query: (id) => ({
                url: buildUrl(`/dashboard/${id}`),
                method: 'GET',
            }),
            providesTags: (result, error, id) => [{ type: 'BusinessIntelligenceDashboards', id }],
        }),
        // An inline dashboard is posted whole - its cells carry their own report configs - and comes back
        // with the same reportData map a saved dashboard is served with.
        getBiInlineDashboard: builder.query({
            query: (config) => ({
                url: buildUrl(`/dashboard/inline`),
                method: 'POST',
                body: { config },
            }),
            providesTags: () => [{ type: 'BusinessIntelligence' }],
        }),
        createBiDashboard: builder.mutation({
            query: (data) => ({
                url: buildUrl(`/dashboard`),
                method: 'POST',
                body: data,
            }),
            invalidatesTags: () => [{ type: 'BusinessIntelligenceDashboards' }, { type: 'BusinessIntelligenceMenu' }],
        }),
        updateBiDashboard: builder.mutation({
            query: (data) => ({
                url: buildUrl(`/dashboard/${data.id}`),
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'BusinessIntelligenceDashboards', id: arg?.id }, { type: 'BusinessIntelligenceMenu' }],
        }),
        // Quick per-user primary (home default) toggle — the secondary way; the main way is the builder's
        // config.primary on create/update. Refreshes the dashboards list so isPrimary flips everywhere.
        setBiDashboardPrimary: builder.mutation({
            query: ({ id, primary }) => ({
                url: buildUrl(`/dashboard/${id}/primary`),
                method: 'PUT',
                body: { primary },
            }),
            invalidatesTags: () => [{ type: 'BusinessIntelligenceDashboards' }, { type: 'BusinessIntelligenceMenu' }],
        }),
        deleteBiDashboard: builder.mutation({
            query: (id) => ({
                url: buildUrl(`/dashboard/${id}`),
                method: 'DELETE',
            }),
            invalidatesTags: () => [{ type: 'BusinessIntelligenceDashboards' }, { type: 'BusinessIntelligenceMenu' }],
        }),
    })
});

// console.log(apiSlice);
export const { 
    useGetBusinessIntelligenceMenuQuery,
    useGetBiRelationShipperCodesQuery,
    useGetBiDetails2Query,
    useGetBiPivotRowDetailQuery,
    useLazyGetBiPivotRowDetailQuery,
    useSaveBusinessIntelligenceReportMutation,
    useGetBiDetailsByIdQuery,
    useDeleteBiReportByIdMutation,
    useEditBiReportByIdMutation,
    useGetBusinessIntelligenceReportsQuery,
    useGetBiDashboardsQuery,
    useGetBiDashboardByIdQuery,
    useGetBiInlineDashboardQuery,
    useCreateBiDashboardMutation,
    useUpdateBiDashboardMutation,
    useDeleteBiDashboardMutation,
    useSetBiDashboardPrimaryMutation,
} = ordersApiSlice;
